import { render, staticRenderFns } from "./AdminRecievedTickets.vue?vue&type=template&id=f6fd33c0&"
import script from "./AdminRecievedTickets.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminRecievedTickets.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports